import React, { useState } from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  TextField,
  Button,
  Grid,
  Tabs,
  Tab,
  Chip,
  IconButton,
  Container,
  Paper,
  InputAdornment,
  Fab,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider,
  Avatar
} from '@mui/material';
import {
  Add,
  Search,
  FileDownload,
  Business,
  Delete,
  Edit,
  Close,
  LocationOn,
  Email,
  Person,
  Phone
} from '@mui/icons-material';

const theme = {
  primary: '#0d6efd',
  primaryLight: '#4285f4',
  primaryDark: '#0a58ca',
  background: '#f8f9fa',
  surface: '#ffffff',
  text: '#212529',
  textSecondary: '#6c757d'
};

const AddCompanyForm = ({ onMainContact, onClose }) => {
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
    if (newValue === 1) {
      onMainContact();
    }
  };

  return (
    <Dialog open={true} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        bgcolor: theme.primary,
        color: 'white'
      }}>
        <Typography variant="h6">Add New Company</Typography>
        <Box sx={{ display: 'flex', gap: 1 }}>
          <Button
            variant="contained"
            size="small"
            startIcon={<FileDownload />}
            sx={{ bgcolor: 'rgba(255,255,255,0.2)', '&:hover': { bgcolor: 'rgba(255,255,255,0.3)' } }}
          >
            Export
          </Button>
          <IconButton onClick={onClose} sx={{ color: 'white' }}>
            <Close />
          </IconButton>
        </Box>
      </DialogTitle>
      
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={tabValue} onChange={handleTabChange} sx={{ px: 3 }}>
          <Tab label="Company Details" />
          <Tab label="Main Contact" />
        </Tabs>
      </Box>

      <DialogContent sx={{ p: 0 }}>
        <Box sx={{ p: 3 }}>
          <Card elevation={0} sx={{ border: '1px solid #e0e0e0' }}>
            <CardContent>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                <Typography variant="h6" sx={{ color: theme.text, fontWeight: 600 }}>
                  Company Information
                </Typography>
                <IconButton color="error" size="small">
                  <Delete />
                </IconButton>
              </Box>

              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="ARA ID"
                    variant="outlined"
                    size="small"
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        '&.Mui-focused fieldset': { borderColor: theme.primary }
                      },
                      '& .MuiInputLabel-root.Mui-focused': { color: theme.primary }
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Company Name"
                    variant="outlined"
                    size="small"
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        '&.Mui-focused fieldset': { borderColor: theme.primary }
                      },
                      '& .MuiInputLabel-root.Mui-focused': { color: theme.primary }
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Street"
                    variant="outlined"
                    size="small"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <LocationOn sx={{ color: theme.textSecondary, fontSize: 20 }} />
                        </InputAdornment>
                      ),
                    }}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        '&.Mui-focused fieldset': { borderColor: theme.primary }
                      },
                      '& .MuiInputLabel-root.Mui-focused': { color: theme.primary }
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Street 2"
                    variant="outlined"
                    size="small"
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        '&.Mui-focused fieldset': { borderColor: theme.primary }
                      },
                      '& .MuiInputLabel-root.Mui-focused': { color: theme.primary }
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextField
                    fullWidth
                    label="City"
                    variant="outlined"
                    size="small"
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        '&.Mui-focused fieldset': { borderColor: theme.primary }
                      },
                      '& .MuiInputLabel-root.Mui-focused': { color: theme.primary }
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextField
                    fullWidth
                    label="State"
                    variant="outlined"
                    size="small"
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        '&.Mui-focused fieldset': { borderColor: theme.primary }
                      },
                      '& .MuiInputLabel-root.Mui-focused': { color: theme.primary }
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextField
                    fullWidth
                    label="Zipcode"
                    variant="outlined"
                    size="small"
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        '&.Mui-focused fieldset': { borderColor: theme.primary }
                      },
                      '& .MuiInputLabel-root.Mui-focused': { color: theme.primary }
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextField
                    fullWidth
                    label="Type"
                    variant="outlined"
                    size="small"
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        '&.Mui-focused fieldset': { borderColor: theme.primary }
                      },
                      '& .MuiInputLabel-root.Mui-focused': { color: theme.primary }
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Lender Name"
                    variant="outlined"
                    size="small"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Person sx={{ color: theme.textSecondary, fontSize: 20 }} />
                        </InputAdornment>
                      ),
                    }}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        '&.Mui-focused fieldset': { borderColor: theme.primary }
                      },
                      '& .MuiInputLabel-root.Mui-focused': { color: theme.primary }
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Lender Email"
                    type="email"
                    variant="outlined"
                    size="small"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Email sx={{ color: theme.textSecondary, fontSize: 20 }} />
                        </InputAdornment>
                      ),
                    }}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        '&.Mui-focused fieldset': { borderColor: theme.primary }
                      },
                      '& .MuiInputLabel-root.Mui-focused': { color: theme.primary }
                    }}
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Box>
      </DialogContent>

      <DialogActions sx={{ p: 3, bgcolor: theme.background }}>
        <Button onClick={onClose} sx={{ color: theme.textSecondary }}>
          Cancel
        </Button>
        <Button
          variant="contained"
          sx={{
            bgcolor: theme.primary,
            '&:hover': { bgcolor: theme.primaryDark }
          }}
        >
          Next
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const CompanyDetailsCard = ({ company, onClick }) => (
  <Card 
    sx={{ 
      mb: 2, 
      cursor: 'pointer',
      transition: 'all 0.2s ease-in-out',
      '&:hover': { 
        transform: 'translateY(-2px)',
        boxShadow: '0 4px 20px rgba(13, 110, 253, 0.15)'
      }
    }}
    onClick={onClick}
  >
    <CardContent>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Avatar sx={{ bgcolor: theme.primary }}>
            <Business />
          </Avatar>
          <Box>
            <Typography variant="h6" sx={{ fontWeight: 600, color: theme.text }}>
              {company.company}
            </Typography>
            <Typography variant="body2" color="textSecondary">
              ID: {company.araId}
            </Typography>
          </Box>
        </Box>
        <Chip
          label={company.Status}
          size="small"
          sx={{
            bgcolor: company.Status === 'Active' ? '#e8f5e8' : '#ffeaa7',
            color: company.Status === 'Active' ? '#27ae60' : '#f39c12',
            fontWeight: 600
          }}
        />
      </Box>
      
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <LocationOn sx={{ fontSize: 16, color: theme.textSecondary }} />
            <Typography variant="body2" color="textSecondary">
              {company.street}, {company.city}, {company.state} {company.zipcode}
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography variant="body2" color="textSecondary">
            Type: {company.officeType || 'Head Office'}
          </Typography>
        </Grid>
      </Grid>
    </CardContent>
  </Card>
);

const CompanyDetails = ({ company, onClose }) => {
  const [showAddForm, setShowAddForm] = useState(false);
  const [showMainContact, setShowMainContact] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');

  // Mock data for demonstration
  const companies = [
    {
      araId: 'ARA001',
      company: 'Tech Solutions Inc.',
      street: '123 Main St',
      street2: 'Suite 100',
      city: 'San Francisco',
      state: 'CA',
      zipcode: '94102',
      officeType: 'Head Office',
      Status: 'Active'
    },
    {
      araId: 'ARA002',
      company: 'Global Industries LLC',
      street: '456 Business Ave',
      city: 'New York',
      state: 'NY',
      zipcode: '10001',
      officeType: 'Branch Office',
      Status: 'Active'
    }
  ];

  const filteredCompanies = companies.filter(comp =>
    comp.company.toLowerCase().includes(searchTerm.toLowerCase()) ||
    comp.city.toLowerCase().includes(searchTerm.toLowerCase()) ||
    comp.state.toLowerCase().includes(searchTerm.toLowerCase()) ||
    comp.zipcode.includes(searchTerm)
  );

  const toggleAddForm = () => {
    setShowAddForm(!showAddForm);
    setShowMainContact(false);
  };

  const showMainContactForm = () => {
    setShowMainContact(true);
  };

  if (showAddForm) {
    return <AddCompanyForm 
      onMainContact={showMainContactForm} 
      onClose={() => setShowAddForm(false)} 
    />;
  }

  return (
    <Container maxWidth="lg" sx={{ py: 3 }}>
      <Paper elevation={0} sx={{ p: 3, bgcolor: theme.surface, borderRadius: 2 }}>
        {/* Header */}
        <Box sx={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center', 
          mb: 4,
          flexWrap: 'wrap',
          gap: 2
        }}>
          <Typography variant="h4" sx={{ 
            fontWeight: 700, 
            color: theme.text,
            background: `linear-gradient(45deg, ${theme.primary}, ${theme.primaryLight})`,
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent'
          }}>
            Company Management
          </Typography>
          <Button
            variant="outlined"
            startIcon={<FileDownload />}
            sx={{
              borderColor: theme.primary,
              color: theme.primary,
              '&:hover': {
                bgcolor: theme.primary,
                color: 'white'
              }
            }}
          >
            Export Data
          </Button>
        </Box>

        {/* Search and Add Section */}
        <Box sx={{ 
          display: 'flex', 
          gap: 2, 
          mb: 3,
          flexDirection: { xs: 'column', sm: 'row' },
          alignItems: { xs: 'stretch', sm: 'center' }
        }}>
          <TextField
            fullWidth
            placeholder="Search companies by name, city, state, or zipcode..."
            variant="outlined"
            size="small"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search sx={{ color: theme.textSecondary }} />
                </InputAdornment>
              ),
            }}
            sx={{
              '& .MuiOutlinedInput-root': {
                '&.Mui-focused fieldset': { borderColor: theme.primary }
              }
            }}
          />
          <Button
            variant="contained"
            startIcon={<Add />}
            onClick={toggleAddForm}
            sx={{
              bgcolor: theme.primary,
              minWidth: { xs: '100%', sm: 'auto' },
              whiteSpace: 'nowrap',
              '&:hover': { bgcolor: theme.primaryDark }
            }}
          >
            Add Company
          </Button>
        </Box>

        <Divider sx={{ mb: 3 }} />

        {/* Companies List */}
        <Box>
          <Typography variant="h6" sx={{ mb: 2, fontWeight: 600, color: theme.text }}>
            Companies ({filteredCompanies.length})
          </Typography>
          
          {filteredCompanies.length > 0 ? (
            filteredCompanies.map((comp, index) => (
              <CompanyDetailsCard
                key={index}
                company={comp}
                onClick={() => console.log('Company clicked:', comp)}
              />
            ))
          ) : (
            <Paper 
              sx={{ 
                p: 4, 
                textAlign: 'center', 
                bgcolor: theme.background,
                border: '2px dashed #e0e0e0'
              }}
            >
              <Business sx={{ fontSize: 64, color: theme.textSecondary, mb: 2 }} />
              <Typography variant="h6" color="textSecondary" gutterBottom>
                No companies found
              </Typography>
              <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
                {searchTerm ? 'Try adjusting your search terms' : 'Get started by adding your first company'}
              </Typography>
              {!searchTerm && (
                <Button
                  variant="contained"
                  startIcon={<Add />}
                  onClick={toggleAddForm}
                  sx={{
                    bgcolor: theme.primary,
                    '&:hover': { bgcolor: theme.primaryDark }
                  }}
                >
                  Add First Company
                </Button>
              )}
            </Paper>
          )}
        </Box>
      </Paper>

      {/* Floating Action Button for Mobile */}
      <Fab
        color="primary"
        onClick={toggleAddForm}
        sx={{
          position: 'fixed',
          bottom: 24,
          right: 24,
          display: { xs: 'flex', sm: 'none' },
          bgcolor: theme.primary,
          '&:hover': { bgcolor: theme.primaryDark }
        }}
      >
        <Add />
      </Fab>
    </Container>
  );
};

export default CompanyDetails;